<template>
	<div id="interestsCard" class="interestsCard">
		<h2>Select your interests</h2>
		<div class="select_container-interests">
      <!-- Start Loop Here -->
      <template v-if="interests" v-for="interest in interests">
        <div @click="addToSelectedOrRemoveFromSelected(interest)" class="select_container-interests-item" :class="{ active: checkInterest(interest)}" :key="interest.id">
          <div class="select_container-interests-item-icon">
            <img :src="'/static/img/interests/' + interestId(interest) + '.svg'" />
          </div>
          <div class="select_container-interests-item-text">
            <p>{{ interestName(interest) }}</p>
          </div>
        </div>
      </template>
		</div>
  </div>
</template>

<script>
    export default {
      name: 'interests-card',
      data () {
        return {
          selectedInterests: []
        }
      },
      computed: {
        interests () {
          return this.$store.getters.interests
        },
        user () {
          return this.$store.getters.user
        }
      },
      mounted: function () {
        this.$store.dispatch('getInterests').then((response) => {
          this.$nextTick(function () {
            this.populateselectedInterests()
          })
        })
      },
      methods: {
        interestName (interest) {
          return interest.name
        },
        interestId (interest) {
          return interest.id
        },
        populateselectedInterests () {
          let userInterests = this.user.interests
          if (userInterests.length > 0 && this.interests.length > 0) {
            userInterests.forEach(userInterest => {
              this.interests.forEach(interest => {
                if (userInterest.id === interest.id) {
                  let index = this.selectedInterests.indexOf(interest.id)
                  if (index === -1) {
                    this.selectedInterests.push(interest.id)
                  }
                }
              })
            })
          }
        },
        checkInterest (interest) {
          if (this.selectedInterests.length > 0) {
            let index = this.selectedInterests.indexOf(interest.id)
            if (index > -1) {
              return true
            }
          }
          return false
        },
        addToSelectedOrRemoveFromSelected (interest) {
          let index = this.selectedInterests.indexOf(interest.id)
          if (index > -1) {
            this.selectedInterests.splice(index, 1)
          } else {
            this.selectedInterests.push(interest.id)
          }
          this.updateUserInterests()
        },
        updateUserInterests () {
          window.alertify.dismissAll()
          this.$store.dispatch('updateUserInterests', {
            'interests': this.selectedInterests
          }).then((response) => {
            this.$nextTick(function () {
              window.alertify.success('Interests saved!')
              this.populateselectedInterests()
              this.$store.dispatch('getCards')
            })
          })
        }
      }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cards/Interests.vue